import { SourceTypes } from "@common/types/server-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GetSourceByIdResult {
  success: boolean;
  data?: SourceTypes;
  error?: string;
}

export const querySourceByIdUseCase = async (
  sourceId: string,
  shouldRequestNodeset = false,
  signal?: AbortSignal,
): Promise<GetSourceByIdResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getSourceById(
      namespace,
      sourceId,
      shouldRequestNodeset,
      signal,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch source by ID").message,
    };
  }
};
